// extracted by extract-css-chunks-webpack-plugin
module.exports = {"static-page":"static-page__static-page"};